import * as React from 'react';

import './Impressum.scss';

class Impressum extends React.Component {
    public render() {
        return <div>
            <h1>Impressum</h1>
            <div className="container impressum">
                <p><span>&nbsp;</span></p>
                <p><span>Offenlegung nach § 25 Mediengesetz</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Region Villach Tourismus GmbH</span></p>
                <p><span>Peraustraße 32</span></p>
                <p><span>9500 Villach, Österreich</span></p>
                <p><span>Tel.: +43 4242 42 000</span></p>
                <p><span>Fax: +43 4242 &nbsp;42 000 - 42</span></p>
                <p><span>E-Mail:office@region-villach.at</span></p>
                <p><span>
                    <a href="http://www.visitvillach.at">www.visitvillach.at</a>&nbsp;
  </span></p>
                <p><span>Firmenbuchnummer: FN171412b</span></p>
                <p><span>Firmenbuchgericht: LG Klagenfurt</span></p>
                <p><span>UID: ATU45187907&nbsp;</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Informationspflicht lt. § 5 Abs. 1 E-Commerce-Gesetz</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Tätigkeitsbereich:</span></p>
                <p><span>Ferientourismus für Individualkunden</span></p>
                <p><span>Kontingentpartner für Reiseveranstalter</span></p>
                <p><span>Gruppengeschäft für Busunternehmer und Vereinsreisen</span></p>
                <p><span>Incentives</span></p>
                <p><span>Seminar- &amp; Kongresstourismus</span></p>
                <p><span>Kur- &amp; Wellnesstourismus</span></p>
                <p><span>Marketing für Tourismusbetriebe</span></p>
                <p><span>Incoming</span></p>
                <p><span>Tourismusinformationsstelle&nbsp;</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Rechtliche Hinweise:&nbsp;</span></p>
                <p><span>Der Inhalt dieser Website ist urheberrechtlich geschützt. Die Bereitstellung von Inhalten und Bildmaterial dieses Tourismusportales auf anderen Websites ist nur mit ausdrücklicher Genehmigung der Redaktion gestattet.</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Die auf dieser Website enthaltenen Angaben werden nach bestem Wissen erstellt und mit großer Sorgfalt auf ihre Richtigkeit überprüft. Trotzdem sind inhaltliche und sachliche Fehler nicht vollständig auszuschließen. Die Region Villach Tourismus GmbH übernimmt keinerlei Garantie und Haftung für die Richtigkeit, Aktualität und Vollständigkeit der bereitgestellten Informationen. Alle Angaben sind ohne Gewähr. Dies gilt auch für alle auf diesem Tourismusportal genannten Links zu anderen Websites.</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>„Informationen zur Online-Streitbeilegung gemäß Art. 14. Abs. 1 ODR-VO:</span></p>
                <p><span>Die EU-Kommission bietet die Möglichkeit zur Online-Streitbeilegung auf einer von ihr betriebene Platttform (sog. „OS-Plattform“). Die OS-Plattform kann als Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten aus Online-Kaufverträgen oder Dienstleistungsverträgen dienen. Diese Plattform ist über den externen Link:
    <a href="http://ec.europa.eu/consumers/odr">http://ec.europa.eu/consumers/odr</a> zu erreichen.
  </span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Links auf diese Website sind erwünscht, soweit sie als externe Links geführt werden und jeweils ganze Seiten (inkl. Navigationsframe) wiedergegeben werden. Eine Übernahme des Hauptfensters in einen Frame des Linksetzers ist unzulässig. Eigene Links auf fremde Seiten stellen nur Wegweiser zu diesen Seiten dar; sie werden deshalb regelmäßig mittels externem Link in einem eigenen Browserfenster dargestellt. Der Herausgeber identifiziert sich nicht mit dem Inhalt der Seiten, auf die verwiesen wird und übernimmt dafür keine Haftung. Sollte eine der Seiten, auf die verwiesen wird, bedenkliche Inhalte aufweisen, wird um Mitteilung ersucht; in so einem Falle wird der Link sofort gelöscht</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Soweit im Content personenbezogene Bezeichnungen nur in männlicher Form angeführt sind, beziehen sie sich auf Frauen und Männer in gleicher Weise. Mit dieser Maßnahme wollen wir die optimale Lesbarkeit der Website sicherstellen.</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Für die Richtigkeit und Aktualität der Informationen zu den Unterkünften, Vakanzdaten und Pauschalangeboten sind die jeweiligen Betriebe selbst verantwortlich. Die Region Villach Tourismus GmbH tritt dabei lediglich als Vermittler, jedoch nicht als Vertragspartner auf.&nbsp;</span></p>
                <p><span>&nbsp;</span></p>
                <p><span>Design &amp; Technische Konzeption:</span></p>
                <p><span>Infrastil</span></p>
                <p><span>Bergsiedlung 32<br />&nbsp;9500 Villach</span></p>
                <p><span>
                    <a href="http://www.infrastil.com">www.infrastil.com</a>
                </span></p>
                <p ><span >&nbsp;</span></p>
                <p><span>Haftung:</span></p>
                <p><span >Sämtliche Inhalte wurden sorgfältig geprüft. Dessen ungeachtet kann keine Garantie für Richtigkeit, Vollständigkeit und Aktualität der Angaben übernommen werden.</span>&nbsp;</p>
            </div>
        </div>;
    }
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/components/layout/Header/Impressum.tsx